export default "__VITE_ASSET__7OiXwjEG__"